// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1wx6W","choiceBoxes":"toolbarselects_choiceBoxes__N4PBB","simpleField":"toolbarselects_simpleField__3pjwj"};